module.exports = __webpack_public_path__ + "static/media/ford-logo.588615ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/new_components/generic/png/ford-logo.png
// module id = 7355
// module chunks = 4